const theme = {
  font: {
    primary: `'Prata', serif`,
    secondary: `'Average', serif`,
  },
  font_size: {
    small: 'font-size: 14px; line-height: 30px',
    regular: 'font-size: 19px; line-height: 32px',
    large: 'font-size: 25px; line-height: 40px',
    larger: 'font-size: 31px; line-height: 48px',
    xlarge: 'font-size: 43px; line-height: 56px',
  },
  color: {
    white: {
      regular: '#FFFFFF',
      dark: '#F6F6F6',
    },
    black: {
      lighter: '#ABA8AF',
      light: '#564F62',
      regular: '#211E26',
    },
    primary: '#8bd8ed',
  },
  screen: {
    xs: '575px',
    sm: '767px',
    md: '991px',
    lg: '1199px',
  },
};

export default theme;
